import Close from '../../img/icons/close.png'
import CircleIcon from '@mui/icons-material/Circle'

function CalendarModal(props) {

    return (
        <div className="informationpopup--background">
            <div className="informationpopup--container appeloffre--modal__container">
                <img src={Close} alt="Close popup" className="informationpopup--close" onClick={() => props.closeModal()} />
                <h3 className="appeloffre--modal__title">Calendrier de consultation</h3>
                {props.dateFinSouscription && <p className="appeloffre--modal__text">
                    <CircleIcon sx={{ fontSize: "9px", color: "#48AB4D" }} />
                    <span className="appeloffre--modal__date">{new Date(props.dateFinSouscription).toLocaleDateString()} :<br /></span>
                    Date limite d'enregistrement des consommateurs sur le site WattValue et de signature des mandats.
                </p>}
                {((props.dateB3Diffusion && props.isGaz) || (props.dateB3DiffusionIndicatif && !props.isGaz)) && <p className="appeloffre--modal__text">
                    <CircleIcon sx={{ fontSize: "9px", color: "#48AB4D" }} />
                    <span className="appeloffre--modal__date">{props.isGaz ? new Date(props.dateB3Diffusion).toLocaleDateString() : new Date(props.dateB3DiffusionIndicatif).toLocaleDateString()} :<br /></span>
                    Publication de la base de données consommateurs aux fournisseurs, sur la plateforme WattValue.
                </p>}
                {props.datePrixIndicatif && <p className="appeloffre--modal__text">
                    <CircleIcon sx={{ fontSize: "9px", color: "#48AB4D" }} />
                    <span className="appeloffre--modal__date">{new Date(props.datePrixIndicatif).toLocaleDateString()} :<br /></span>
                    Remise de l'offre indicative par les fournisseurs. Ces prix indicatifs sont communiqués au consommateur le jour même.
                </p>}

                {((props.dateB3DiffusionDefinitif && props.isGaz) || (props.dateB3Diffusion && !props.isGaz)) && <p className="appeloffre--modal__text">
                    <CircleIcon sx={{ fontSize: "9px", color: "#48AB4D" }} />
                    <span className="appeloffre--modal__date">{props.isGaz ? new Date(props.dateB3DiffusionDefinitif).toLocaleDateString() : new Date(props.dateB3Diffusion).toLocaleDateString()} :<br /></span>
                    La base de données consommateurs finale à jour est communiquée aux fournisseurs.
                </p>}
                {((props.datePrixDefinitif && props.isGaz) || (props.dateFinRemiseB3 && !props.isGaz)) && <p className="appeloffre--modal__text">
                    <CircleIcon sx={{ fontSize: "9px", color: "#48AB4D" }} />
                    <span className="appeloffre--modal__date">{props.isGaz ? new Date(props.datePrixDefinitif).toLocaleDateString() : new Date(props.dateFinRemiseB3).toLocaleDateString()} :<br /></span>
                    Remise de l'offre finale engageante. Réponse de WattValue le jour même avec attribution du portefeuille, pour émission et signature des contrats pour un début de fourniture dans la continuité des contrats en cours.
                </p>}
                {(
                    !props.dateFinSouscription &&
                    !((props.dateB3Diffusion && props.iGaz) || (props.dateB3DiffusionIndicatif && !props.isGaz)) &&
                    !props.datePrixIndicatif &&
                    !((props.dateB3DiffusionDefinitif && props.isGaz) || (props.dateB3Diffusion && !props.isGaz)) &&
                    !((props.datePrixDefinitif && props.isGaz) || (props.dateFinRemiseB3 && !props.isGaz))
                ) ?
                    <p className="appeloffre--modal__text">
                        Pas encore de calendrier pour cet appel d'offres
                    </p>
                    :
                    <></>
                }
            </div>
        </div>
    )
}

export default CalendarModal